import api from '@/api';

const state = {
  organizerConfig: {
    basic_info: {},
    theme_config: {},
    login_config: {},
    exam_config: {},
    notification_config: {},
    grading_config: {},
    feature_config: {},
    limits_config: {}
  },
  themePresets: [
    {
      id: 'professional',
      name: '专业蓝主题',
      description: '稳重专业，适合教育机构',
      colors: {
        primary: '#1976d2',
        primary_light: '#42a5f5',
        primary_dark: '#1565c0'
      }
    },
    {
      id: 'fresh',
      name: '清新绿主题', 
      description: '清新自然，适合现代企业',
      colors: {
        primary: '#43a047',
        primary_light: '#66bb6a',
        primary_dark: '#388e3c'
      }
    },
    {
      id: 'warm',
      name: '温暖橙主题',
      description: '温暖活力，适合培训机构',
      colors: {
        primary: '#fb8c00',
        primary_light: '#ffa726',
        primary_dark: '#f57c00'
      }
    },
    {
      id: 'elegant',
      name: '优雅灰主题',
      description: '简约优雅，适合正式考试',
      colors: {
        primary: '#546e7a',
        primary_light: '#78909c',
        primary_dark: '#455a64'
      }
    }
  ]
};

const getters = {
  organizerConfig: state => state.organizerConfig,
  basicInfo: state => state.organizerConfig.basic_info,
  themeConfig: state => state.organizerConfig.theme_config,
  loginConfig: state => state.organizerConfig.login_config,
  examConfig: state => state.organizerConfig.exam_config,
  notificationConfig: state => state.organizerConfig.notification_config,
  gradingConfig: state => state.organizerConfig.grading_config,
  featureConfig: state => state.organizerConfig.feature_config,
  limitsConfig: state => state.organizerConfig.limits_config,
  themePresets: state => state.themePresets
};

const mutations = {
  SET_ORGANIZER_CONFIG(state, config) {
    state.organizerConfig = { ...state.organizerConfig, ...config };
  },
  
  SET_BASIC_INFO(state, basicInfo) {
    state.organizerConfig.basic_info = basicInfo;
  },
  
  SET_THEME_CONFIG(state, themeConfig) {
    state.organizerConfig.theme_config = themeConfig;
  },
  
  SET_LOGIN_CONFIG(state, loginConfig) {
    state.organizerConfig.login_config = loginConfig;
  },
  
  SET_EXAM_CONFIG(state, examConfig) {
    state.organizerConfig.exam_config = examConfig;
  },
  
  SET_NOTIFICATION_CONFIG(state, notificationConfig) {
    state.organizerConfig.notification_config = notificationConfig;
  },
  
  SET_GRADING_CONFIG(state, gradingConfig) {
    state.organizerConfig.grading_config = gradingConfig;
  },
  
  SET_FEATURE_CONFIG(state, featureConfig) {
    state.organizerConfig.feature_config = featureConfig;
  },
  
  SET_LIMITS_CONFIG(state, limitsConfig) {
    state.organizerConfig.limits_config = limitsConfig;
  }
};

const actions = {
  // 获取举办方配置
  async fetchOrganizerConfig({ commit }, organizerId) {
    try {
      const response = await api.config.getOrganizerConfig(organizerId);
      commit('SET_ORGANIZER_CONFIG', response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 更新基础信息
  async updateBasicInfo({ commit }, { organizerId, basicInfo }) {
    try {
      const response = await api.config.updateBasicInfo(organizerId, basicInfo);
      commit('SET_BASIC_INFO', response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 更新主题配置
  async updateThemeConfig({ commit }, { organizerId, themeConfig }) {
    try {
      const response = await api.config.updateThemeConfig(organizerId, themeConfig);
      commit('SET_THEME_CONFIG', response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 更新登录配置
  async updateLoginConfig({ commit }, { organizerId, loginConfig }) {
    try {
      const response = await api.config.updateLoginConfig(organizerId, loginConfig);
      commit('SET_LOGIN_CONFIG', response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 更新考试配置
  async updateExamConfig({ commit }, { organizerId, examConfig }) {
    try {
      const response = await api.config.updateExamConfig(organizerId, examConfig);
      commit('SET_EXAM_CONFIG', response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 更新通知配置
  async updateNotificationConfig({ commit }, { organizerId, notificationConfig }) {
    try {
      const response = await api.config.updateNotificationConfig(organizerId, notificationConfig);
      commit('SET_NOTIFICATION_CONFIG', response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 更新阅卷配置
  async updateGradingConfig({ commit }, { organizerId, gradingConfig }) {
    try {
      const response = await api.config.updateGradingConfig(organizerId, gradingConfig);
      commit('SET_GRADING_CONFIG', response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 更新功能配置
  async updateFeatureConfig({ commit }, { organizerId, featureConfig }) {
    try {
      const response = await api.config.updateFeatureConfig(organizerId, featureConfig);
      commit('SET_FEATURE_CONFIG', response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 更新限制配置
  async updateLimitsConfig({ commit }, { organizerId, limitsConfig }) {
    try {
      const response = await api.config.updateLimitsConfig(organizerId, limitsConfig);
      commit('SET_LIMITS_CONFIG', response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 预览主题
  async previewTheme({ }, { organizerId, themeConfig }) {
    try {
      const response = await api.config.previewTheme(organizerId, themeConfig);
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
